import api from '@/lib/api';
import type { PaginatedResponse, ChargeType, ChargeTypeCategory } from '@pms/shared';

// ─── Query / payload types ────────────────────────────────────────────────────

export interface ListChargeTypesQuery {
  propertyId: string;
  search?: string | undefined;
  isActive?: boolean | undefined;
  page?: number | undefined;
  limit?: number | undefined;
}

export interface CreateChargeTypePayload {
  propertyId: string;
  name: string;
  code: string;
  category: ChargeTypeCategory;
  defaultAmount?: number | undefined;
  taxable?: boolean | undefined;
  postingCode?: string | undefined;
  isActive?: boolean | undefined;
}

export interface UpdateChargeTypePayload {
  name?: string | undefined;
  code?: string | undefined;
  category?: ChargeTypeCategory | undefined;
  defaultAmount?: number | undefined;
  taxable?: boolean | undefined;
  postingCode?: string | undefined;
  isActive?: boolean | undefined;
}

// ─── API functions ────────────────────────────────────────────────────────────

export async function fetchChargeTypes(
  query: ListChargeTypesQuery,
): Promise<PaginatedResponse<ChargeType>> {
  const { data } = await api.get<PaginatedResponse<ChargeType>>('/charge-types', {
    params: query,
  });
  return data;
}

export async function createChargeType(
  payload: CreateChargeTypePayload,
): Promise<ChargeType> {
  const { data } = await api.post<ChargeType>('/charge-types', payload);
  return data;
}

export async function updateChargeType(
  id: string,
  payload: UpdateChargeTypePayload,
): Promise<ChargeType> {
  const { data } = await api.patch<ChargeType>(`/charge-types/${id}`, payload);
  return data;
}

export async function deleteChargeType(id: string): Promise<void> {
  await api.delete(`/charge-types/${id}`);
}
